import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from './index';

const initialState: any = {
    settings: null,
};

const KYCDigioSignSlice = createSlice({
    name: 'KYCDigioSign',
    initialState,
    reducers: {
        setKYCDigioSignSlice(state, action: PayloadAction<any>) {
            state.settings = action.payload;
        },
    },
});

export const getKYCDigioSignSettings = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await fetch('/kyc-digio-sign.json');
            const data = await response.json();
            await dispatch(KYCDigioSignSlice.actions.setKYCDigioSignSlice(data));
        } catch (err) {
            console.log('error from KYCDigioSignSlice', err);
        }
    };
};

export default KYCDigioSignSlice.reducer;
export const { setKYCDigioSignSlice } = KYCDigioSignSlice.actions;
